import { render, staticRenderFns } from "./MessageWindow.vue?vue&type=template&id=321c21c6&"
import script from "./MessageWindow.vue?vue&type=script&scoped=true&lang=js&"
export * from "./MessageWindow.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./MessageWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports